import { DEFAULT_CONTACT_LIST_ITEMS } from 'src/constants/contacts-list-item-default'
import { DEFAULT_LISTS } from 'src/constants/default-lists'
import { CONTACTS_STRING_KEYS } from './contacts-list-types'

// Extracts the inner flat filter object from the first filter group.
// All default lists currently have at most one group; this would silently
// drop additional groups if that ever changes.
function extractFlatFilters (list) {
  const filters = list.filters

  if (!Array.isArray(filters) || !filters.length) {
    return {}
  }

  return filters[0].filters || {}
}

const lists = Object.keys(DEFAULT_LISTS).reduce((acc, key) => {
  acc[key] = { ...DEFAULT_LISTS[key], filters: extractFlatFilters(DEFAULT_LISTS[key]) }
  return acc
}, {})

export const DEFAULT_STATE = {
  listItems: CONTACTS_STRING_KEYS.reduce((list, key) => {
    list[key] = DEFAULT_CONTACT_LIST_ITEMS
    return list
  }, {}),
  lists,
  columns: null,
  folders: [],
  isFiltersOpen: false,
  opened: [],
  pinned: [],
  pinnedCounts: {
    all: 0,
    'my-contacts': 0,
    unassigned: 0,
    unanswered: 0,
    'new-leads': 0
  },
  removeContact: null,
  removeContactActionType: null,
  isBulkDelete: false,
  removeFolder: null,
  removeList: null,
  moveDialog: {
    open: false,
    id: null,
    type: 'folder',
    target: null
  },
  selectedList: {
    id: 'all',
    name: 'All Contacts'
  },
  selectedStaticList: {
    id: null,
    name: '',
    type: null,
    hasEdit: 0,
    hasDelete: 0
  },
  createList: {
    name: '',
    mode: '', // from_filters, from_bulk_menu, from_folders
    type: 1,
    open: false,
    contact_folder_id: null,
    filters: [],
    show_in_public_folder: false
  },
  selectList: {
    contact_list_id: null,
    open: false,
    search_value: ''
  },
  filters: [],
  currentListFilters: {},

  contact: {},
  contactPhoneNumbers: [],
  contactRingGroups: [],
  contactAttributes: [],
  isSidebarCollapsed: false,
  isContactNameEditOpen: false,
  lines: [],
  ringGroups: [],
  contactSelectedPhone: null,
  selectedLine: null,
  messageComposer: {
    mode: 'sms',
    sms: {
      body: '',
      phone_number: null,
      attachments: [],
      gif_url: '',
      schedule_date: null
    },

    fax: {
      filename: ''
    },

    email: {
      subject: '',
      body: '',
      attachments: []
    },
    note: {
      body: '',
      type: 10,
      date: null,
      time: null,
      timezone: null
    }
  },
  isScheduleMessageOpen: false,
  isScheduledMessageListOpen: false,
  isAddAppointmentOpen: false,
  isAppointmentSubmitted: false,
  isAddPowerDialerOpen: false,
  isMergeContactOpen: false,
  isEnrollSequenceOpen: false,
  isAddReminderOpen: false,
  isOptoutActive: true,
  optoutText: '\nText STOP to unsubscribe.',
  changingSelectedContact: false,
  smsTemplateModal: {
    open: false,
    scope: 'user',
    template: null
  },
  search: '',
  searchedPdItem: '',
  showMenu: false,
  showContactsHeader: true,
  showContactsListSidebar: false,
  showMyContacts: false,
  showAddViewMyContacts: false,
  unsavedList: null,
  activeFolder: '',
  pinnedListsLoaded: false,
  publicListsLoaded: false,
  myListsLoaded: false,
  listContactsLoaded: false,
  previousListFilters: {},
  previouslySavedListId: null,
  previousListId: null,
  sequenceInfo: {
    sequence: null,
    workflow: null
  },
  sequenceInfoLoading: false,
  lineIncomingNumber: null,
  lineIncomingNumberLoading: false,
  communicationsSummary: {
    first_outbound_call: null,
    summaries: {
      inbound_calls_count: 0,
      outbound_calls_count: 0,
      inbound_texts_count: 0,
      outbound_texts_count: 0,
      total_count: 0
    }
  },
  isContactMixinUsed: false,
  isShortenedUrlRemembered: false,
  newCommunicationInprogressContactFetch: [],
  inProgressAxiosUniqueIds: []
}
